import { app_version } from "./tool";
let ua = navigator.userAgent;
let href = location.href;
let is_weibo = /[w|W]eibo/.test(ua);
let weibo_version = "";
let is_afd_client = /afdian/.test(ua);
let is_ios = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
let is_iPhone = ua.indexOf("iPhone") > -1;
let is_iPad = (ua.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
let is_android = ua.indexOf("Android") > -1;
let is_huawei = (/huawei|honor/i).test(ua);
let is_abroad = 0;
if (is_weibo) {
    let arr = ua.match(/__weibo__(\d+\.)+\d_/);
    if (arr && arr[0]) {
        weibo_version = arr[0].replace("weibo", "").replace(/_/g, "");
    }
}
let is_app_audio = false;
if (
    (is_afd_client && is_ios && app_version("1.2.1") == "higher") ||
    (is_android && app_version("0.0.20") == "higher")
) {
    is_app_audio = true;
}


let can_app_play_info = false;
if (
    (is_afd_client && is_ios && app_version("1.3.5") == "higher") ||
    (is_android && app_version("0.0.30") == "higher" || app_version("0.0.30") == "same")
) {
    can_app_play_info = true;
}

let ios_version = '';
if(is_ios){
    let arr = ua.match(/Version\/(\d+)/); //移动端
    if(!arr){
        arr = ua.match(/iPhone\sOS\s(\d{2})/) //afdian
    }
    if(arr && arr[1]){
        ios_version = arr[1];
    }
}
let afd_version = app_version();

let can_iPad_bridge = app_version("1.3.4") == "higher" || app_version("1.3.4") == "same";

// let is_huawei_apply = (/HUAWEI|harmony/ig).test(navigator.userAgent) && app_version("0.0.44") == "same"
let is_huawei_apply = false

function isPwa() {     
  var displayModes = ["fullscreen", "standalone", "minimal-ui"];     
  return displayModes.some((displayMode) => window.matchMedia('(display-mode: ' + displayMode + ')').matches); 
}

let crawler_match = /googlebot|bingbot|spider/i
export default {
    ua,
    appstore:'https://apps.apple.com/cn/app/id1436428322',
    // androidstore:'http://app.mi.com/details?id=net.afdian.afdian',
    androidstore:'https://h5coml.vivo.com.cn/h5coml/appdetail_h5/browser_v2/index.html?appId=2894965',
    // yingyongbao:'https://sj.qq.com/myapp/detail.htm?apkName=net.afdian.afdian',
    yingyongbao:'https://a.app.qq.com/o/simple.jsp?pkgname=net.afdian.afdian',
    applink_host: 'https://uljump.afdian.net',
    is_wechat: /MicroMessenger/.test(ua) && !/wxwork/.test(ua),
    is_alipay: /AlipayClient/.test(ua),
    is_mobile: !!ua.match(/AppleWebKit.*Mobile.*/) || is_iPhone || is_android || is_iPad, //是否为移动终端
    is_safari: ua.indexOf("Safari") > -1,
    is_chrome: ua.indexOf("Chrome") > -1,
    is_ios, //ios终端
    is_android, //android终端
    is_iPad, //是否iPad
    is_weibo, //是否微博,
    weibo_version,
    ios_version,
    is_wechat_mini:
        /MicroMessenger/.test(ua) && /client_env=miniprogram/i.test(href), //是否是小程序 ios的ua 无法判断出小程序
    is_afd_client,
    is_local_dev: !/afdian.net/.test(location.host),
    is_beta: /74db138637d611e887|138637d611e887f852540025c377|alphaffb601b2a2f6aa9a50179dbfe46883b7/.test(location.host),
    is_pro: location.origin == "https://afdian.net",
    is_app_audio,
    is_applying_apple:false,
    is_applying_google:false,
    can_iPad_bridge,
    is_xiaoyuzhou: /Xiaoyuzhou/.test(ua), //小宇宙播客 app
    can_app_play_info,
    is_abroad,
    is_huawei,
    is_bug_weibo: is_weibo
        ? (is_ios && weibo_version.replace(/\./g, "") >= 993) || //某个版本之后
          ua.indexOf("WeiboIntlAndroid") != -1 || //国际版
          !is_ios
        : false,
    afd_version,
    is_huawei_apply,
    is_pwa: navigator.standalone || isPwa(),
    is_mac_wechat:ua.indexOf('MacWechat') != -1 && ua.indexOf('Mac OS') != -1,
    is_window_wechat:ua.indexOf('WindowsWechat') != -1 && ua.indexOf('Mac') == -1,
    is_channel_google: is_afd_client && ua.indexOf('Channel/google') != -1,
    is_crawler: crawler_match.test(ua)
};
